export default {
    seo: {
        title: '',
        description: ''
    },
    title: 'Blog and News',
    shortTitle: 'Blog',
    socialTitle: 'Follow us on:',
    readMore: 'Read more '
}
